import { useLines } from '@/providers/lines/use-lines';
import { $apiAllo } from '@/services/api-allo/client';

export const useNumberConfig = (phoneNumber?: string) => {
  const { currentLine } = useLines();

  // Use || (not ??) so callers passing '' (the `currentNumber.number ?? ''`
  // pattern from number-settings) fall back to currentLine instead of sending
  // an empty path param.
  const number = phoneNumber || currentLine.phoneNumber.number.format('E.164');

  const settingsQueryParams = [
    'get',
    '/v1/number/{number}/config',
    {
      params: {
        path: {
          number,
        },
      },
    },
  ] as const;

  return { ...$apiAllo.useQuery(...settingsQueryParams), settingsQueryParams };
};
